import React, { Component } from "react";
import Hero from "./Hero";
import Approach from "./Approach";
import Services from "./Services";
import Work from "./Work";
import Clients from "./Client";
import Contact from "./Contact";
import Slider from "./Client/Slider";
import TopSlider from "./TopSlider";
import windowDimensions from "react-window-dimensions";

const Mainpage = ({ width, height }) => {
  return (
    <div>
      <TopSlider />
      <Slider
        screenWidth={{
          width
        }}
      />  
      <Services />
      <Approach />
      <Work />
      <Contact />
    </div>
  );
};

export default windowDimensions()(Mainpage);



// WEBPACK FOOTER //
// ./src/components/Mainpage/Mainpage.js